'use strict';

const $toggle = $('.tutorial-toggle');
const $close = $('.tutorial-close');

const $overlay = $('.tutorial-overlay');
const $intro = $('.tutorial-intro');

let active = false;

function toggle() {
	active ? hide() : show();
}

function show() {
	active = true;
	$overlay.fadeIn();
	$intro.fadeIn(1);
	$('[data-tutorial-tip]').attr('data-tutorial-active', true);
}

function hide() {
	active = false;
	$overlay.fadeOut();
	$intro.fadeOut(1);
	$('[data-tutorial-tip]').attr('data-tutorial-active', false);
}

$toggle.on('click', toggle);
$close.on('click', hide);

module.exports = { show, hide };
